<template>
  <IllustratedSection
    class="bg-lightblue-400"
    illustration="notification-error"
    outlined
    smaller-headline-spacing
  >
    <template #headline>{{ $t('richinbox.syncerror.headline') }}</template>
    <template #subtitle>{{ $t('richinbox.syncerror.description') }}</template>

    <LcButton @click="$emit('retry')">{{ $t('richinbox.syncerror.cta') }}</LcButton>
  </IllustratedSection>
</template>

<script lang="ts" setup>
type Emits = { retry: [] }

defineEmits<Emits>()
</script>
